/*
 * ce-auto-slider.js — auto-advance for a Dawn <slider-component> carrying `data-ce-autoplay="<ms>"`.
 * WHY JS: the reference slider steps one card every N seconds (discrete, looping) — a scroll position change
 * over time, which CSS cannot drive. Cost: one interval per slider, paused while hovered / focused / touched,
 * while off-screen (IntersectionObserver) and under `prefers-reduced-motion`. Snap scrolling stays native.
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const init = () => {
    document.querySelectorAll('slider-component[data-ce-autoplay]').forEach((component) => {
      if (component.ceAutoplay) return;
      const slider = component.querySelector('[id^="Slider-"]');
      const items = component.querySelectorAll('[id^="Slide-"]');
      if (!slider || items.length < 2) return;
      const delay = Math.max(1500, Number(component.dataset.ceAutoplay) || 5000);
      let paused = false;
      let visible = false;
      const step = () => {
        if (paused || !visible) return;
        const first = items[0];
        const second = items[1];
        const offset = second.offsetLeft - first.offsetLeft; // one card + gap
        const atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 2;
        slider.scrollTo({ left: atEnd ? 0 : slider.scrollLeft + offset, behavior: 'smooth' });
      };
      component.ceAutoplay = setInterval(step, delay);
      ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach((e) => component.addEventListener(e, () => (paused = true), { passive: true }));
      ['mouseleave', 'focusout'].forEach((e) => component.addEventListener(e, () => (paused = false)));
      new IntersectionObserver((entries) => (visible = entries[0].isIntersecting), { threshold: 0.2 }).observe(component);
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
